export const BODY_GRID_AREA = 'body';
export const HEADER_GRID_AREA = 'header';
export const SIDEBAR_GRID_AREA = 'sidebar';
export const FOOTER_GRID_AREA = 'footer';

export const TEMPLATE_AREA = `
  "${HEADER_GRID_AREA} ${SIDEBAR_GRID_AREA}"
  "${BODY_GRID_AREA} ${SIDEBAR_GRID_AREA}"
  "${FOOTER_GRID_AREA} ${SIDEBAR_GRID_AREA}"
`;

export const WEB_VIEW_TEMPLATE_AREA = `
  "${HEADER_GRID_AREA}"
  "${BODY_GRID_AREA}"
  "${SIDEBAR_GRID_AREA}"
  "${FOOTER_GRID_AREA}"
`;
